import React, { useState, useEffect } from 'react';
import api from '../services/api';
import PortalLayout, { card, StateMsg } from '../components/PortalLayout';

const A = '#00D4AA';

export default function Tweefactor() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stap, setStap] = useState('idle');
  const [qr, setQr] = useState(null);
  const [secret, setSecret] = useState(null);
  const [code, setCode] = useState('');
  const [recovery, setRecovery] = useState([]);
  const [busy, setBusy] = useState(false);
  const [disableCode, setDisableCode] = useState('');

  const laadStatus = async () => {
    try { const r = await api.get('/klantportaal/2fa/status'); setStatus(r.data); }
    catch (e) { setError('Kon status niet laden'); }
    finally { setLoading(false); }
  };
  useEffect(() => { laadStatus(); }, []);

  const start = async () => {
    setError(null); setBusy(true);
    try { const r = await api.post('/klantportaal/2fa/setup-start'); setQr(r.data.qr); setSecret(r.data.secret); setStap('setup'); }
    catch (e) { setError(e.response?.data?.message || 'Kon niet starten'); }
    finally { setBusy(false); }
  };
  const verify = async () => {
    setError(null); setBusy(true);
    try { const r = await api.post('/klantportaal/2fa/setup-verify', { code: code.trim() }); setRecovery(r.data.recovery_codes || []); setStap('recovery'); setCode(''); }
    catch (e) { setError(e.response?.data?.message || 'Onjuiste code'); }
    finally { setBusy(false); }
  };
  const klaar = async () => { setStap('idle'); setQr(null); setSecret(null); setRecovery([]); setError(null); setLoading(true); await laadStatus(); };
  const uitschakelen = async () => {
    setError(null); setBusy(true);
    try { await api.post('/klantportaal/2fa/disable', { code: disableCode.trim() }); setDisableCode(''); setLoading(true); await laadStatus(); }
    catch (e) { setError(e.response?.data?.message || 'Kon niet uitschakelen'); }
    finally { setBusy(false); }
  };

  const knop = { background: A, color: '#062b24', border: 'none', borderRadius: 10, padding: '13px', fontWeight: 700, fontSize: 15, width: '100%', cursor: 'pointer' };
  const inp = { width: '100%', boxSizing: 'border-box', padding: '12px 14px', border: '1px solid #e2e8f0', borderRadius: 10, fontSize: 18, textAlign: 'center', letterSpacing: 3, marginBottom: 12 };

  return (
    <PortalLayout titel="Tweestapsverificatie">
      <StateMsg loading={loading} error={stap === 'idle' ? error : null} />
      {!loading && status && stap === 'idle' && (
        <div style={{ ...card, padding: 18 }}>
          {status.enabled ? (
            <>
              <div style={{ color: '#16a34a', fontWeight: 700, fontSize: 15 }}>&#x2705; 2FA is actief</div>
              <p style={{ color: '#64748b', fontSize: 13, marginTop: 6 }}>Je account is extra beveiligd met een authenticator-app.</p>
              {status.verplicht ? (
                <p style={{ color: '#94a3b8', fontSize: 12, marginTop: 10 }}>2FA is verplicht voor jouw rol en kan niet worden uitgeschakeld.</p>
              ) : (
                <div style={{ marginTop: 14 }}>
                  <p style={{ color: '#64748b', fontSize: 13 }}>Uitschakelen? Voer een code uit je app in:</p>
                  <input value={disableCode} onChange={(e) => setDisableCode(e.target.value)} placeholder="123456" style={{ ...inp, marginBottom: 10 }} />
                  {error && <div style={{ color: '#dc2626', fontSize: 13, marginBottom: 8 }}>{error}</div>}
                  <button onClick={uitschakelen} disabled={busy} style={{ ...knop, background: '#dc2626', color: '#fff' }}>2FA uitschakelen</button>
                </div>
              )}
            </>
          ) : (
            <>
              <div style={{ fontWeight: 700, color: '#1e293b', fontSize: 15 }}>2FA staat uit</div>
              <p style={{ color: '#64748b', fontSize: 13, margin: '6px 0 14px' }}>
                {status.verplicht ? 'Voor jouw rol is 2FA verplicht. Schakel het nu in.' : 'Beveilig je account extra met een authenticator-app (Google of Microsoft Authenticator).'}
              </p>
              <button onClick={start} disabled={busy} style={knop}>2FA inschakelen</button>
            </>
          )}
        </div>
      )}

      {stap === 'setup' && (
        <div style={{ ...card, padding: 18, textAlign: 'center' }}>
          <p style={{ color: '#1e293b', fontWeight: 700, fontSize: 15 }}>1. Scan met je authenticator-app</p>
          {qr && <img src={qr} alt="QR-code" style={{ width: 200, height: 200, margin: '10px auto' }} />}
          <p style={{ color: '#64748b', fontSize: 12 }}>Of voer deze sleutel handmatig in:</p>
          <code style={{ display: 'block', wordBreak: 'break-all', background: '#f1f5f9', padding: 8, borderRadius: 8, fontSize: 12, margin: '4px 0 16px' }}>{secret}</code>
          <p style={{ color: '#1e293b', fontWeight: 700, fontSize: 15, textAlign: 'left' }}>2. Voer de code uit de app in</p>
          <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="123456" style={inp} />
          {error && <div style={{ color: '#dc2626', fontSize: 13, marginBottom: 8 }}>{error}</div>}
          <button onClick={verify} disabled={busy} style={knop}>Bevestigen</button>
        </div>
      )}

      {stap === 'recovery' && (
        <div style={{ ...card, padding: 18 }}>
          <div style={{ color: '#16a34a', fontWeight: 700, fontSize: 15 }}>&#x2705; 2FA ingeschakeld</div>
          <p style={{ color: '#64748b', fontSize: 13, marginTop: 6 }}>Bewaar deze herstelcodes op een veilige plek. Elke code werkt &eacute;&eacute;n keer als je geen toegang hebt tot je app.</p>
          <div style={{ background: '#f1f5f9', borderRadius: 8, padding: 12, margin: '12px 0', fontFamily: 'monospace', fontSize: 14, lineHeight: 1.8, textAlign: 'center' }}>
            {recovery.map((c) => <div key={c}>{c}</div>)}
          </div>
          <button onClick={klaar} style={knop}>Ik heb ze opgeslagen</button>
        </div>
      )}
    </PortalLayout>
  );
}
